import { empty as empty_1 } from "../fable-library.3.2.6/Map.js";
import { ExtraCoders } from "./Types.fs.js";

export const empty = new ExtraCoders("", empty_1());

